export enum DigitMode {
  THREE_DIGIT = '3',
  TWO_DIGIT = '2',
  FOUR = '4',
  SIX = '6',
  RUNNING = 'running',
}

export enum BetTypeEnum {
  THREE_TOP = 'bet_three_top',
  THREE_TOD = 'bet_three_tod',
  TWO_TOP = 'bet_two_top',
  TWO_TOD = 'bet_two_tod',
  TWO_UNDER = 'bet_two_under',
  RUN_TOP = 'bet_run_top',
  RUN_BOTTOM = 'bet_run_bottom',
  THREE_FRONT = 'bet_three_front',
  THREE_FRONT_TOD = 'bet_three_front_tod',
  THREE_UNDER = 'bet_three_under',
  FOUR = 'bet_four',
  SIX = 'bet_six',
}
export enum TwoNumberPatternEnum {
  FRONT_RUNNING = 'frontRunning',
  END_RUNNING = 'endRunning',
  NINETEEN_NUMBER = '19Number',
}
// Helper functions for bet types
export const isThreeDigitBet = (betType: BetTypeEnum): boolean => {
  return [
    BetTypeEnum.THREE_TOP,
    BetTypeEnum.THREE_TOD,
    BetTypeEnum.THREE_FRONT,
    BetTypeEnum.THREE_FRONT_TOD,
    BetTypeEnum.THREE_UNDER,
  ].includes(betType as BetTypeEnum)
}

export const isTwoDigitBet = (betType: BetTypeEnum): boolean => {
  return [
    BetTypeEnum.TWO_TOP,
    BetTypeEnum.TWO_TOD,
    BetTypeEnum.TWO_UNDER,
  ].includes(betType as BetTypeEnum)
}

export const isRunningBet = (betType: BetTypeEnum): boolean => {
  return [BetTypeEnum.RUN_TOP, BetTypeEnum.RUN_BOTTOM].includes(
    betType as BetTypeEnum,
  )
}

export const isFourDigitBet = (betType: BetTypeEnum): boolean => {
  return betType === BetTypeEnum.FOUR
}

export const isSixDigitBet = (betType: BetTypeEnum): boolean => {
  return betType === BetTypeEnum.SIX
}

export type TabType = 'bet' | 'shoot' | 'rules' | 'result'
export type PanelType = 'panel' | 'manual'

export interface BetLottoProps {
  gameType: string
  gameId: number
  roundId: number
  title: string
  isActive?: boolean
  roundEndTime?: Date
  onBetAction: (
    gameInfo: { gameId: number; roundId: number; gameType: string },
    bets: LottoBetList[],
  ) => void
  onChangeBetPrice?: (amount: number) => void
  onChangeSingleBetPrice?: (
    type: BetTypeEnum,
    number: string,
    amount: number,
  ) => void
  onDeleteItem?: (type: BetTypeEnum, number: string, idx: number) => void
  creditLeft: number
  roundNumber?: number | string
}
export interface GameData {
  gameId: number
  roundId: number
  gameType:
    | 'yeekee'
    | 'malta'
    | 'india'
    | 'germany'
    | 'england'
    | 'dowjones'
    | 'vietnam'
    | 'thai-stock'
    | 'thai-bank'
    | 'thai-gov'
    | 'china'
    | 'japan'
    | 'korea'
    | 'laos'
    | 'malaysia'
    | 'russia'
    | 'singapore'
    | 'taiwan'
    | 'egypt'
    | 'hangseng'
}

export type LottoItem = {
  number: string
  price: number
  winPrice: number
  rate: number
}

export type LottoBetList = {
  name: string
  type: BetTypeEnum
  rate: number
  items: LottoItem[]
}

export interface BetData {
  number: string
  type: BetTypeEnum
  rate: number
  amount: number
}

export interface BetControlsProps {
  betData: LottoBetList[]
  onChangeSingleBetPrice: (type: string, idx: number, newPrice: number) => void
  onDeleteItem: (key: number, type: string) => void
  // onBetDataChange: (bets: BetData[]) => void
  onClearAll: () => void
  onBetSubmit: () => void
  // onRemoveBet: (bet: BetData) => void
  onChangeBetPrice: (newPrice: number) => void
  totalBetAmount?: string
  creditLeft?: string
}
